<template>
  <div>
    <div ref="videoContainer" class="video-container" id="video-container">
      <video class="video" ref="video" preload="metadata">
        <source :src="src" type="video/mp4" />
      </video>

      <div class="video-controls hidden" id="video-controls">
        <div class="video-progress">
          <progress
            id="progress-bar"
            :value="progress"
            min="0"
            :max="duration"
          ></progress>
          <input
            class="seek"
            id="seek"
            v-model="progress"
            min="0"
            :max="duration"
            type="range"
            step="1"
            @input="changeProgress"
          />
        </div>

        <div class="bottom-controls">
          <div class="left-controls">
            <button v-if="!playing" @click="play">
              <Icon family="fa" name="fa-play" helperClass="has-text-white" />
            </button>
            <button v-if="playing" @click="pause">
              <Icon family="fa" name="fa-pause" helperClass="has-text-white" />
            </button>

            <div class="volume-controls">
              <button v-if="!muted" @click="mute">
                <Icon
                  family="fa"
                  name="fa-volume-up"
                  helperClass="has-text-white"
                />
              </button>

              <button v-if="muted" @click="unmute">
                <Icon
                  family="fa"
                  name="fa-volume-slash"
                  helperClass="has-text-white"
                />
              </button>

              <input
                class="volume"
                ref="volume"
                v-model="volume"
                type="range"
                max="1"
                min="0"
                step="0.01"
              />
            </div>

            <div class="time">
              <time id="time-elapsed">{{ currentTime }}</time>
              <span> / </span>
              <time id="duration">{{ durationTime }}</time>
            </div>
          </div>

          <div class="right-controls">
            <button v-if="!expanded" @click="expand">
              <Icon family="fa" name="fa-expand" helperClass="has-text-white" />
            </button>
            <button v-if="expanded" @click="compress">
              <Icon
                family="fa"
                name="fa-compress"
                helperClass="has-text-white"
              />
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "video-player",
  props: {
    src: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      video: null,
      videoLoaded: false,
      currentTime: "00:00",
      progress: 0,
      volume: 1,
      playing: false,
      muted: false,
      expanded: false,
      videocontrols: true,
    };
  },
  mounted() {
    this.video = this.$refs.video;
    this.video.addEventListener("loadedmetadata", this.initializeVideo);
    this.video.addEventListener("timeupdate", this.updateCurrentTime);
    this.video.addEventListener("timeupdate", this.updateProgress);
    //this.video.addEventListener("play", this.playVideo);
    //this.video.addEventListener("pause", this.pauseVideo);
    this.$refs.volume.addEventListener("input", this.updateVolume);
    this.video.addEventListener("mouseleave", this.mouseleaveVideo);
    this.video.addEventListener("mouseenter", this.mouseenterVideo);
  },
  computed: {
    duration() {
      return this.videoLoaded ? Math.round(this.video.duration) : 0;
    },
    durationTime() {
      if (this.videoLoaded) {
        let time = this.formatTime(this.duration);
        return `${time.minutes}:${time.seconds}`;
      }
      return "";
    },
  },
  methods: {
    mouseleaveVideo() {
      if (this.video) {
        this.videocontrols = false;
      }
    },
    mouseenterVideo() {
      if (this.video) {
        this.videocontrols = true;
      }
    },
    initializeVideo() {
      this.videoLoaded = true;
    },
    async updateCurrentTime() {
      let time = this.formatTime(Math.round(this.video.currentTime));
      this.currentTime = `${time.minutes}:${time.seconds}`;
    },
    async updateProgress() {
      this.progress = Math.floor(this.video.currentTime);
    },
    updateVolume() {
      if (this.video.muted) {
        this.mute();
      }

      this.video.volume = this.$refs.volume.value;
      if (this.video.volume === 0) {
        this.muted = true;
      } else {
        this.muted = false;
      }
    },
    formatTime(time) {
      const result = new Date(time * 1000).toISOString().substr(11, 8);

      return {
        minutes: result.substr(3, 2),
        seconds: result.substr(6, 2),
      };
    },
    play() {
      this.video.play();
      this.playing = true;
    },
    pause() {
      this.video.pause();
      this.playing = false;
    },
    mute() {
      this.video.muted = true;
      this.muted = true;
      this.volume = 0;
    },
    unmute() {
      this.video.muted = false;
      this.muted = false;
      this.volume = 0.7;
    },
    expand() {
      if (this.$refs.videoContainer.webkitRequestFullscreen) {
        // Need this to support Safari
        this.$refs.videoContainer.webkitRequestFullscreen();
      } else {
        this.$refs.videoContainer.requestFullscreen();
      }
      this.expanded = true;
    },
    compress() {
      if (document.fullscreenElement) {
        document.exitFullscreen();
      } else if (document.webkitFullscreenElement) {
        // Need this to support Safari
        document.webkitExitFullscreen();
      }
      this.expanded = false;
    },
    async changeProgress(event) {
      let value = event.target.dataset.seek
        ? event.target.dataset.seek
        : event.target.value;
      this.progress = value;
      //this.video.currentTime = value;
      let time = this.formatTime(Math.round(value));
      this.currentTime = `${time.minutes}:${time.seconds}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/video";
</style>
